const defaultState = {
  form: {
    name: '',
    tel: '',
    email: '',
    password1: '',
    password2: '',
    otp: ''
  }
}

const mutations = {
  SET_FORM (state, payload) {
    state.form = { ...state.form, ...payload }
  },
  RESET_FORM (state) {
    const clear = {
      name: '',
      tel: '',
      email: '',
      password1: '',
      password2: '',
      otp: ''
    }
    state.form = { ...clear }
  }
}

const actions = {
  changeForm ({ commit }, payload) {
    commit('SET_FORM', payload)
  },
  clearForm ({ commit }, payload) {
    commit('RESET_FORM', payload)
  }
}

const getters = {
  form: (state) => state.form
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  mutations,
  getters
}
